<template>
  <div>
    <div class="container">
      <div class="space-100"></div>
      <div class="row justify-content-center row-height">
        <div class="text-center">
          <div>
            <h2><strong>¿Olvidaste tu contraseña?</strong></h2>
          </div>
          <div>
            <p>Tu contraseña es la clave de tu tarjeta o tu codigo postal </p>
          </div>
          <div>
            <div class="alert-success"><h5>{{sentSuccessfull}}</h5></div>
            <div class="alert-danger"><h5>{{notSuccessfull}}</h5></div>
            <div>
              <input id="account" v-model="accountSearch" type="text" name="account" class="email-input" placeholder="Correo electrónico / Telefono"/>
            </div>
            <div>
              <p>
                <button v-on:click="BuscarContra" class="input-button">Buscar</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-footer></main-footer>
  </div>
</template>
<script>
import { Card, Button, FormGroupInput, Modal,  Alert} from '@/components';
import MainFooter from '@/layout/MainFooter';
import moment from 'moment';

export default {
  name: 'login-page',
  data() {
    return {
      sentSuccessfull: '',
      accountSearch: '',
      notSuccessfull: '',
    };
  },
  bodyClass: 'login-page',
  components: {
    Card,
    Alert,
    MainFooter,
    Modal,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  created(){

  },
  methods:{
    BuscarContra(e) {
      if(this.accountSearch === ''){
        this.notSuccessfull = 'Por favor, introduce tu correo o numero de telefono'
      }else{
        this.sentSuccessfull = 'Te hemos enviado tu contraseña a tu correo'
        this.notSuccessfull = ''
      }
    }
  }
};
</script>
<style lang="scss">
</style>
